import { render, staticRenderFns } from "./verify-acc.vue?vue&type=template&id=2dc8228b&scoped=true"
import script from "./verify-acc.vue?vue&type=script&lang=js"
export * from "./verify-acc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8228b",
  null
  
)

export default component.exports